import { render, staticRenderFns } from "./encyclopediaBritannica.vue?vue&type=template&id=68cd644f&scoped=true&"
import script from "./encyclopediaBritannica.vue?vue&type=script&lang=js&"
export * from "./encyclopediaBritannica.vue?vue&type=script&lang=js&"
import style0 from "./encyclopediaBritannica.vue?vue&type=style&index=0&id=68cd644f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd644f",
  null
  
)

export default component.exports